const ApiBaseUrl = process.env.REACT_APP_HOST || "https://localhost:7185";
const RecaptchaBaseUrl = "https://recaptchaenterprise.googleapis.com/v1/projects";

export { ApiBaseUrl, RecaptchaBaseUrl };
